import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../../shared/security.service';
import { GroupGuard } from '../../shared/group.guard';

@Injectable()
export class ConversionsResidentDocMoveGuard extends GroupGuard {
  constructor(securityService: SecurityService, router: Router) {
    super(securityService, router);

    this.validGroups = ["mc.emp.at.resdocmigrate"];
  }
}
